import styled from "styled-components";
import { Field } from "formik";

export const Container = styled.div`
  background: transparent linear-gradient(90deg, #eeeeee 0%, #f8f8f8 100%) 0% 0%
    no-repeat padding-box;
  position: relative;
`;
export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 700px;
  width: 100%;
  text-align: center;
  margin-inline: auto;
  padding-top: 50px;
  padding-bottom: 130px;
  position: relative;
  @media (max-width: 992px) {
    padding-top: 150px;
    padding-bottom: 7rem;
    text-align: center;
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;
export const SectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;
export const MarqueeItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 -140px;
`;

export const LeftSection = styled.div`
  background: linear-gradient(to bottom right, #24a18b, #349c86c6);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  overflow: hidden;
  .desktop-icons {
    position: relative;
  }

  /* Mobile vs desktop display control */
  .mobile-marquee {
    display: none;
    position: absolute;
    width: 100%;
    z-index: 999;
    top: 73%;
  }

  @media screen and (max-width: 992px) {
    .icon1,
    .icon2,
    .icon3,
    .icon4,
    .icon5 {
      display: none;
    }

    .mobile-marquee {
      display: block;
    }
  }

  /* Desktop positioning */
  @media screen and (min-width: 992px) {
    .icon1 {
      position: absolute;
      transform: translate(40%, -50%);
      height: auto;
      z-index: 999;
    }
    .icon2 {
      position: absolute;
      transform: translate(-40%, 2%);
      height: auto;
      z-index: 9999;
    }
    .icon3 {
      position: absolute;
      transform: translate(40%, 22%);
      height: auto;
      z-index: 9999;
    }
    .icon4 {
      position: absolute;
      transform: translate(-40%, 46%);
      height: auto;
      z-index: 9999;
    }
    .icon5 {
      position: absolute;
      transform: translate(40%, 70%);
      height: auto;
      z-index: 9999;
    }
  }
`;

export const PhoneImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  max-width: 500px;
  z-index: 1;

  /* z-index: 999; */
`;
export const Title = styled.div`
  color: white;
  margin: 60px 0 0 0;
  font-family: RubikMedium;
`;
export const BottomImage = styled.img`
  width: auto;
  height: auto;
  position: absolute;
  bottom: 0;
  left: 0;
  height: 50%;
`;
export const RightSection = styled.div`
  padding: 50px;
  h2 {
    color: #142c1f;
  }
  p {
    color: #142c1f;
    margin: 30px 0px;
  }
`;
export const FieldLabel = styled.label`
  display: block;
  font-size: 14px;
  color: #44554c;
  margin-bottom: 10px;
  font-weight: 500;
  letter-spacing: 0.42px;
`;
export const FieldRow = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const InputField = styled(Field)`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 4px;
  background-color: white;
  font-size: 12px;
  // placeholder color
  ::placeholder {
    color: #a5b5af;
  }
  &:focus {
    outline: none;
    border: 1px solid #2ecf96;
  }
`;

export const FieldContainer = styled.div`
  position: relative;
  flex: 1;
`;
export const ErrorText = styled.div`
  color: #d32f2f;
  margin-top: 4px;
`;
export const TextAreaField = styled(Field)`
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: none;
  border-radius: 4px;
  background-color: white;
  font-size: 12px;
  resize: vertical;
  font-family: inherit;
  vertical-align: top;
  padding-bottom: 120px;

  // placeholder color
  ::placeholder {
    color: #a5b5af;
  }

  &:focus {
    outline: none;
    border: 1px solid #c0c0c0;
  }
`;
export const ButtonWrapper = styled.button`
  margin-top: 30px;
  z-index: 9999;
  position: relative;
  @media (max-width: 992px) {
    width: 100% !important;
  }
`;

export const BottomTitle = styled.div`
  color: white;
  margin: 60px 0 0 0;
  font-family: RubikMedium;
  position: relative;
  top: -20px;
`;
export const StyledPhoneInputWrapper = styled.div`
  .PhoneInput {
    width: 100%;
    height: 43px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    &:focus-within {
      border: 1px solid #2ecf96;
    }

    .PhoneInputCountry {
      margin-right: 10px;
      margin-left: 10px;
    }

    .PhoneInputInput {
      flex: 1;
      border: none;
      background-color: transparent;
      font-size: 16px;
      padding: 12px 0;
      outline: none;

      &::placeholder {
        color: #a5b5af;
      }
    }
  }
`;
